// src/components/Pages/Account.js

import { useTranslation } from 'react-i18next';

import { CircularProgress, Container, Grid, Stack, Typography } from '@mui/material';

import { useRetrieveUserQuery } from '../../redux/features/authApi';
import { AccountProfile } from '../Apm/Profile/AccountProfile';
import { AccountProfileDetails } from '../Apm/Profile/AccountProfileDetails';

const Account = () => {
  const { t } = useTranslation();

  const { data: account, isLoading, isFetching, isError } = useRetrieveUserQuery();

  if (isLoading && !account) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 300 }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (isError || !account) {
    return (
      <Typography color="error" align="center" sx={{ py: 5 }}>
        {t('toast.account_could_not_be_loaded', {
          defaultValue: 'Account could not be loaded.',
        })}
      </Typography>
    );
  }

  console.log('ACCOUNT:', account);

  return (
    <Container
      component="main"
      maxWidth="lg"
      sx={{
        py: {
          xs: 3,
          sm: 5,
          md: 8,
        },
        px: {
          xs: 2,
          sm: 3,
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
        <Typography component="h1" variant="h4">
          {t('general.account_profile')}
        </Typography>

        {isFetching && <CircularProgress size={18} />}
      </Stack>

      <Grid container spacing={4} alignItems="flex-start">
        <Grid item xs={12} md={4}>
          <AccountProfile account={account} />
        </Grid>

        <Grid item xs={12} md={8}>
          <AccountProfileDetails mode="account" account={account} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Account;
